import { FormGroup } from "@angular/forms";
import { ConjunctionEnum } from "../../../../../shared/models/conjunction.enum";
import { ResolvedRequestOptionsService } from "../../../../services/resolved-request-options";
import { PollinationTypeEnum } from "../../../../../shared/services/pollination-stake-label.service";
var PollinationPreferenceItemListComponent = /** @class */ (function () {
    function PollinationPreferenceItemListComponent(routeData) {
        this.routeData = routeData;
        this.pollinationTypeEnum = PollinationTypeEnum;
        this.pollinationTypes = this.routeData.requestOptions.pollinationTypes;
    }
    Object.defineProperty(PollinationPreferenceItemListComponent.prototype, "conjunctionEnum", {
        get: function () {
            return ConjunctionEnum;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PollinationPreferenceItemListComponent.prototype, "items", {
        get: function () {
            return this.preferenceGroup.get("items");
        },
        enumerable: true,
        configurable: true
    });
    PollinationPreferenceItemListComponent.prototype.getPollinationTypeName = function (pollinationTypeId) {
        if (!pollinationTypeId || !this.pollinationTypes) {
            return '';
        }
        var pollinationType = this.pollinationTypes.find(function (pt) { return pt.id === pollinationTypeId; });
        return pollinationType ? pollinationType.name : '';
    };
    return PollinationPreferenceItemListComponent;
}());
export { PollinationPreferenceItemListComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/pollination-instructions/pollination-preference-group/pollination-preference-item-list/pollination-preference-item-list.component.ts.pre-build-optimizer.js